import React from 'react';

export const realisedTooltip = {
    body: (
        <span>
            Profit/Loss (in bps) versus the benchmark on the traded portion of
            the list.
        </span>
    ),
};

export const unrealisedTooltip = {
    body: (
        <span>
            Profit/Loss (in bps) versus the benchmark for the remaining
            unexecuted portion of the list in bps. This uses the last market
            price as the indicative price to compare to the benchmark.
        </span>
    ),
};

export const totalTooltip = {
    body: <span>Realised + Unrealised Profit/Loss (in bps)</span>,
};

export const indexTooltip = {
    body: (
        <span>
            Overlays movement of the selected index (or secondary symbol)
            allowing the user to compare performance against the portfolio.
        </span>
    ),
};
